export class InteriorUpdateLayout {
	public fields = [
		{ fieldName: 'interiorUpdatedComponent', label: 'Component' },
		{ fieldName: 'interiorUpdateType', label: 'Type' },
		{ fieldName: 'interiorUpdateTimeframe', label: 'Timeframe' },
		{ fieldName: 'interiorUpdateDescription', label: 'Description' }
	];
}
